<template>
  <figure class="audio-widget">
      <audio :src="src" :id="refId" controls />
      <figcaption>
        <p class="caption">{{caption}}</p>
      </figcaption>
  </figure>
</template>
<script type="text/javascript">

import filters from "../mixins/filters"
import { extractString } from "../api/helpers"

export default {
  name: "AudioWidget",
  props: {
    item: {
      type: Object,
      required: true,
      default: null
    },
    active: {
      type: Boolean,
      default: false
    },
    auto: {
      type: Boolean,
      default: false
    },
  },
  mixins: [filters],
  watch: {
    active(boolVal) {
      if (this.auto === true && boolVal === false) {
        this.pause();
      }
    }
  },
  computed: {
    preview() {
      return extractString(this.item,'preview');
    },
    src() {
      return extractString(this.item,'src');
    },
    caption() {
      return extractString(this.item,'title');
    },
    refId() {
      const baseName = extractString(this.item,'filename').split('.').shift().toLowerCase();
      return ['audio', baseName].join('--');
    }
  },
  methods: {
    pause() {
      const el = document.getElementById(this.refId);
      if (el instanceof HTMLElement) {
        el.pause();
      }
    }
  }
};
</script>
